var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9929 0C6.58935 1.24502 7.1716 2.49005 7.76805 3.73507C9.17396 3.89925 10.5941 4.04975 12 4.20025C10.9491 5.1306 9.91243 6.06095 8.86154 6.97761C9.14556 8.31841 9.42959 9.6592 9.71361 11C8.47811 10.3296 7.2284 9.6592 5.9929 8.98881C4.7574 9.6592 3.52189 10.3296 2.28639 11C2.57041 9.6592 2.85444 8.31841 3.13846 6.97761C2.08757 6.06095 1.03669 5.1306 0 4.20025C1.40592 4.04975 2.81183 3.89925 4.23195 3.73507C4.8142 2.49005 5.41065 1.24502 5.9929 0Z",
    fill: "#39D512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0e4c41de57de5810a961259bf8ee3e65.svg";
export { ForwardRef as ReactComponent };